<script>
  import WarriorOfTheGods from '$lib/components/WarriorOfTheGods.svelte';
</script>

<WarriorOfTheGods />
